document.addEventListener('DOMContentLoaded', function () {
  const buyNowButtons = document.querySelectorAll('.js-buy-now-btn');

  buyNowButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault();

      const form = this.closest('form');
      const formData = new FormData(form);

      fetch('/cart/clear.js', {
        method: 'POST',
      })
        .then(() => {
          return fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
          });
        })
        .then((response) => response.json())
        .then((data) => {
          window.location.href = '/checkout';
        })
        .catch((error) => {
          console.error('Error:', error);
          alert('There was an error. Please try again.');
        });
    });
  });
});
